import { render } from "./UnilateralNonTrCardOdnostoron.vue?vue&type=template&id=32e75fb6&scoped=true"
import script from "./UnilateralNonTrCardOdnostoron.vue?vue&type=script&lang=js"
export * from "./UnilateralNonTrCardOdnostoron.vue?vue&type=script&lang=js"

import "./UnilateralNonTrCardOdnostoron.vue?vue&type=style&index=0&id=32e75fb6&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e75fb6"]])

export default __exports__